import { VALIDATE_EMAIL_CODE } from 'constants/validate';
import { useCallback, useEffect, useRef, useState } from 'react';
import { userService } from 'services';
import { validateEmail } from 'utils/validates';

const useUserPicker = ({ value = [], onChange }) => {
    const [selectedUsers, setSelectedUsers] = useState(value);
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const timeoutRef = useRef(null);
    const isMounted = useRef(true);

    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    const handleSearch = useCallback(async (query) => {
        if (!query) {
            setOptions([]);
            return;
        }

        setLoading(true);
        try {
            if (validateEmail(query) === VALIDATE_EMAIL_CODE.VALID) {
                const res = await userService.getUserByEmail(query)

                if (res) {
                    setOptions([res]);
                } else {
                    setOptions([]);
                }
            }
        } catch (error) {

        } finally {
            setLoading(false)
        }
    }, []);

    const onInputChange = useCallback((event, newInputValue) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
            handleSearch(newInputValue);
        }, 500);
    }, [handleSearch]);

    const handleSelect = useCallback((user) => {
        if (!user) return;
        const exists = selectedUsers.find((u) => u.user_email === user.user_email || u.user_id === user.user_id);
        if (!exists) {
            const newSelected = [...selectedUsers, user];
            setSelectedUsers(newSelected);
            if (onChange) onChange(newSelected);
            setOptions([])
        }
    }, [selectedUsers, onChange]);

    const handleRemove = useCallback((userToRemove) => {
        const newSelected = selectedUsers.filter(u => u.user_email !== userToRemove.user_email && u.user_id !== userToRemove.user_id);
        setSelectedUsers(newSelected);
        if (onChange) onChange(newSelected);
    }, [selectedUsers, onChange]);

    return {
        selectedUsers,
        options,
        loading,
        onInputChange,
        handleSelect,
        handleRemove
    };
};

export default useUserPicker;